module.exports = __webpack_public_path__ + "img/stamp-fish-summer.ccba25d1.png";